import { Avatar, avatarClasses } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

export const Wrapper = styled(Avatar)`
    &.${avatarClasses.root} {
        color: ${({ theme }) => theme.palette.text.primary};
        background-color: ${({ theme }) => alpha(theme.palette.primary.main, 0.3)};
        font-weight: 500;
    }
`;
